var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { useDeleteClientMutation } from '../../../../application/features/clients/client-api';
import useTranslate from '../../../../localization/helpers';
var DeleteClient = function (_a) {
    var open = _a.open, onClose = _a.onClose, clientId = _a.clientId, clientName = _a.clientName;
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField, tWithFunction = _b.tWithFunction;
    var _c = __read(useDeleteClientMutation(), 2), triggerDeleteClient = _c[0], _d = _c[1], isLoading = _d.isLoading, isSuccess = _d.isSuccess;
    useEffect(function () {
        if (isSuccess) {
            enqueueSnackbar(tWithField('toolTips.deleteSuccess', 'common.client'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            onClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);
    var handleDelete = function () {
        triggerDeleteClient(clientId);
    };
    return (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: 'xs', fullWidth: true, children: [_jsx(DialogTitle, { children: tWithFunction('actions.deleteFunction', 'common.client') }), _jsx(DialogContent, { children: _jsx(DialogContentText, { children: _jsx(Trans, { i18nKey: 'clients.deleteConfirmText', values: { clientName: clientName } }) }) }), _jsxs(DialogActions, { children: [_jsx(Button, { variant: 'outlined', color: 'inherit', onClick: onClose, disabled: isLoading, children: translate('actions.cancel') }), _jsx(Button, { variant: 'contained', color: 'error', onClick: handleDelete, disabled: isLoading, children: translate('actions.delete') })] })] }));
};
export default DeleteClient;
